import { InjectionToken } from '@angular/core';
import { FeatureFlagsState } from './types';

/**
 * Default initial state for feature flags
 */
export const DefaultFeatureFlagsState: FeatureFlagsState = {
  flags: {},
  isLoading: false,
  isReady: false,
  error: null,
  updatingFlag: null,
};

/**
 * Injection token for default feature flags state
 */
export const DEFAULT_FEATURE_FLAGS_STATE =
  new InjectionToken<FeatureFlagsState>('default feature flags state', {
    factory: () => ({ ...DefaultFeatureFlagsState }),
  });
